import React from "react";
import { Instagram, Phone, Mail, MapPin } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const Footer = ({ info }) => {
  const { t } = useLang();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/10 bg-[#0A0A0C] text-white/60"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <img src={`/logo.png?v=5`} alt="İstanbul Organizasyon" className="h-16 w-auto" />
          <p className="mt-6 text-sm leading-relaxed text-white/50 max-w-xs">
            {t("footer.tagline")}
          </p>
        </div>

        <div className="space-y-4">
          <div className="text-xs tracking-[0.25em] uppercase text-[#D4AF37]">
            {t("contact.info.phone")}
          </div>
          {info?.phones?.map((p) => (
            <a
              key={p}
              href={`tel:${p.replace(/\s/g, "")}`}
              className="flex items-center gap-3 text-sm hover:text-white transition-colors"
            >
              <Phone size={14} className="text-[#D4AF37]" /> {p}
            </a>
          ))}
          <a
            href={`mailto:${info?.email}`}
            className="flex items-center gap-3 text-sm hover:text-white transition-colors"
          >
            <Mail size={14} className="text-[#D4AF37]" /> {info?.email}
          </a>
        </div>

        <div className="space-y-4">
          <div className="text-xs tracking-[0.25em] uppercase text-[#D4AF37]">
            {t("contact.info.address")}
          </div>
          <div className="flex items-center gap-3 text-sm">
            <MapPin size={14} className="text-[#D4AF37]" /> {info?.address}
          </div>
          {info?.instagram && (
            <a
              href={info.instagram}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-3 text-sm hover:text-white transition-colors"
              data-testid="footer-instagram"
            >
              <Instagram size={14} className="text-[#D4AF37]" /> Instagram
            </a>
          )}
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <div>
            © {new Date().getFullYear()} İSTANBUL ORGANİZASYON · {t("footer.rights")}
          </div>
          <a href="/admin/login" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-admin-link">
            {t("nav.admin")}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
